/** @jsxRuntime classic */
/** @jsx jsx */
import React, { Component } from "react";
import { connect } from "react-redux";
import onClickOutside from "react-onclickoutside";

import A from "../../../AnchorTemplate/Anchor";
import Link from "../../../LinkTemplate/Link";
import Cart from "../../../Icons/Cart";

import {
  primary_l50,
  primary_s5_l70_a015,
  primary_s20_l70_a025,
} from "../../../lib/colors";
import { jsx, css } from "@emotion/core";

import { removeFromCartEvent } from "../../../lib/gaEnhancedEcommerce";

import Price from "../../../Price/Price";
import SingleCartItem from "./SingleCartItem/SingleCartItem";

import "./CartMenu.scss";

const updateCartQuantity = () => console.log("ciao");
const removeFromCart = () => console.log("ciao");
const getMaxAddable = () => console.log("ciao");

class CartMenu extends Component {
  handleClickOutside = (event) => {
    let { onCloseCartMenu } = this.props;

    return onCloseCartMenu(event);
  };

  decrement = (product) => (event) => {
    event.preventDefault();
    if (product.quantity > 1) {
      this.props.updateCartQuantity(product.id, product.quantity - 1);
    }
  };

  increment = (product) => (event) => {
    event.preventDefault();

    const maxAddable = getMaxAddable(this.props.globalState, product);
    const { minNumInCart } = product;

    if (maxAddable > 0) {
      // Posso aggiungere al carrello
      let newQuantity = product.quantity + 1;

      // Se c'è una quantità minima carrello e non l'ho raggiunta
      if (minNumInCart && product.quantity < minNumInCart) {
        // La nuova quantità è il minimo tra
        // la quantità minima carrello e il numero
        // massimo di pezzi che possono stare nel carrello
        newQuantity = Math.min(minNumInCart, maxAddable + product.quantity);
      }

      // Applico nuova quantità
      this.props.updateCartQuantity(product.id, newQuantity);
    }
  };

  removeFromCart = (product) => (event) => {
    event.preventDefault();
    this.props.removeFromCart(product);

    if (this.props.advancedGa) {
      removeFromCartEvent({
        id: product.code || "",
        name: product.name,
        category: product.categoryName,
        brand: product.brand,
        price: product.price,
        quantity: product.quantity,
      });
    }
  };

  renderCartItems() {
    const { primaryColor, uiVariantButton } = this.props;

    return this.props.cart.map((product) => {
      return (
        <SingleCartItem
          key={product.id}
          product={product}
          onIncrement={this.increment(product)}
          onDecrement={this.decrement(product)}
          onRemove={this.removeFromCart(product)}
          primaryColor={primaryColor}
          uiVariantButton={uiVariantButton}
        />
      );
    });
  }

  renderCartTotal() {
    return this.props.cart.reduce((total, product) => {
      return total + product.price * product.quantity;
    }, 0);
  }

  renderCartItemsQuantity() {
    return this.props.cart.reduce((total, product) => {
      return total + product.quantity;
    }, 0);
  }

  renderCartMenu() {
    const { cart, onCloseAll } = this.props;

    if (cart && cart.length > 0) {
      return (
        <div className="cart-menu">
          <div className="cart-menu-items">{this.renderCartItems()}</div>
          <hr />
          <div className="total">
            <span className="text">Totale:</span>
            <span className="amount">
              <Price amount={this.renderCartTotal()} />
            </span>
          </div>
          <hr />
          <div className="cart-checkout">
            <Link
              to="/carrello"
              className="btn btn-primary"
              onClick={onCloseAll}
            >
              Vai al carrello
            </Link>
          </div>
        </div>
      );
    }

    // Else, no products in cart
    return (
      <div className="cart-menu">
        <div className="total">Non ci sono articoli nel carrello</div>
      </div>
    );
  }

  render() {
    const {
      showCartMenu,
      onToggleCartMenu,
      primaryColor,
      uiVariantButton,
    } = this.props;

    const cartMenuStyle = css`
      &.menu-open .cart-menu:after {
        border-bottom-color: ${primary_s20_l70_a025(primaryColor)}!important;
      }
      .cart-menu {
        border-color: ${primary_s5_l70_a015(primaryColor)}!important;
        box-shadow: 2px 30px 30px 20px
          ${primary_s20_l70_a025(primaryColor)}!important;
      }
      a.cart {
        color: ${primaryColor}!important;
        &:focus,
        &:hover {
          color: ${primary_l50(primaryColor)}!important;
        }

        .badge {
          border-radius: ${uiVariantButton === "1"
            ? "8px"
            : uiVariantButton === "3"
            ? "4px"
            : 0};
        }
      }
    `;

    return (
      <div
        className={`open-cart-menu ${showCartMenu ? "menu-open" : ""}`}
        css={cartMenuStyle}
      >
        <A href="#" onClick={onToggleCartMenu} className="cart">
          <Cart />
          <span className="badge">{this.renderCartItemsQuantity()}</span>
        </A>

        {this.renderCartMenu()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    cart: [],
    advancedGa: state.template.singleTemplate.advancedGa,
    globalState: state,
    primaryColor: state.template.singleTemplate.brandColor,
    uiVariantButton: state.template.singleTemplate.buttons,
  };
}

export default connect(mapStateToProps, { updateCartQuantity, removeFromCart })(
  onClickOutside(CartMenu)
);
